import { render, staticRenderFns } from "./main.vue?vue&type=template&id=6098ae30&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6098ae30')) {
      api.createRecord('6098ae30', component.options)
    } else {
      api.reload('6098ae30', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=6098ae30&", function () {
      api.rerender('6098ae30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/search-table-pagination/src/main.vue"
export default component.exports